




























import { Vue } from "vue-property-decorator";
import Component from "vue-class-component";
import { Mutation, State } from "vuex-class";

import { validationMixin } from "vuelidate";
import { required } from "vuelidate/lib/validators";

import { capitalizeFilter } from "@/filters/capitalize.filter";

import { DoCreateComplaintFirstStepFormData } from "@/interfaces/falcon/do-create-complaint/do-create-complaint-first-step-form-data";

import { I18nMessageKey } from "@/enums/i18n-message-key.enum";
import { FalconComplaintFaultMoment } from "@/enums/falcon/complaints/falcon-complaint-fault-moment.enum";

@Component({
  mixins: [validationMixin],
  filters: {
    ...capitalizeFilter
  },
  validations: {
    defectDescription: { required }
  }
})
export default class ComplaintCreationThirdStepForm extends Vue {
  @Mutation("falconComplaints/defectDescriptionUpdated")
  private defectDescriptionUpdated!: (defectDescription: string) => void;
  @State(state => state.falconComplaints.complaintFormData.defectDescription)
  private complaintDefectDescription!: string;
  @State(state => state.falconComplaints.complaintFormData.details)
  private detailsFormData!: DoCreateComplaintFirstStepFormData;

  defectDescription?: string = "";
  i18nMessageKeyEnum = I18nMessageKey;

  get previousStepUrl(): string {
    let url = "vehicle";
    if (
      this.detailsFormData.faultWhen ===
      FalconComplaintFaultMoment.BeforeAssembly
    ) {
      url = "details";
    }
    return url;
  }

  created(): void {
    this.defectDescription = this.complaintDefectDescription;
  }

  formDataChanged(): void {
    this.defectDescriptionUpdated(this.defectDescription as string);
  }
}
